<div *ngIf="isProtected && !unlocked" class="lock-screen">
  <div class="lock-container">
    <div style="height:150px;">
      <ng-lottie *ngIf="!showUnlockAnimation" [options]="lockedAnimation" style="width: 150px; height: 150px">
      </ng-lottie>

      <ng-lottie *ngIf="showUnlockAnimation" [options]="unlockedAnimation" style="width: 150px; height: 150px">
      </ng-lottie>
    </div>


    <h4 class="lock-title">Catalogue is Password Protected</h4>
    <p class="lock-subtitle">Enter password to unlock and view</p>
    <input type="password" [(ngModel)]="enteredPwd" placeholder="Enter Password" class="password-input" />
    <button (click)="unlock(catalogueId)" class="unlock-btn">Unlock</button>
  </div>
</div>


<div *ngIf="!isProtected || unlocked">
  <div class="main-section" *ngIf="!loading">
    <div *ngIf="showHeader" class="preview-header">
      <button class="back-button" (click)="close()">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
          class="feather feather-arrow-left">
          <line x1="19" y1="12" x2="5" y2="12"></line>
          <polyline points="12 19 5 12 12 5"></polyline>
        </svg>
        <span>Back to Catalogues</span>
      </button>


      <div class="delete-section">
        <button class="delete-button" (click)="printRightPanel()">
          <mat-icon>print</mat-icon>
        </button>

      </div>

    </div>


    <div class="body-class">
      <div class="right-panel" [ngStyle]="{
    'background-color': catalogue?.style?.backgroundColor,
    'margin-top': showHeader ? '56px' : '0'
  }">


        <div *ngIf="!loading" class="preview-cover-section">
          <img *ngIf="catalogue?.coverImage" [src]="catalogue.coverImage" class="preview-cover-image" />
          <div *ngIf="!catalogue?.coverImage" class="no-cover-preview">
            No Cover Image
          </div>

          <div class="cover-overlay"
     [ngStyle]="{
       'justify-content': catalogue.style.coverTextPosition === 'top' ? 'flex-start' :
                          catalogue.style.coverTextPosition === 'bottom' ? 'flex-end' : 'center',
       'align-items': catalogue.style.coverTextAlign === 'left' ? 'flex-start' :
                      catalogue.style.coverTextAlign === 'center' ? 'center' : 'flex-end',
       'text-align': catalogue.style.coverTextAlign
     }">

<div 
  class="company-logo" 
  [ngClass]="[
    'logo-' + (catalogue.style.coverLogoPosition || 'left')
  ]"
>
  <img *ngIf="businessLogo; else fallbackLogo" [src]="businessLogo" alt="Logo" />
  <ng-template #fallbackLogo>
    <div class="company-logo-avatar" [style.backgroundColor]="catalogue.style.secondaryColor">
      {{ getInitials(catalogue.businessData.businessName) }}
    </div>
     <div class="company-logo-name"  [style.color]="catalogue.style.secondaryColor">
                  {{ catalogue.businessData.businessName }}
                </div>
  </ng-template>
</div>

<div 
  class="cover-text" 
  [ngClass]="[
    'text-' + (catalogue.style.coverTextPosition || 'bottom'),
    'align-' + (catalogue.style.coverTextAlign || 'left')
  ]"
>
<h2 class="catalogue-preview-name" [style.fontFamily]="catalogue.style.headingFont"
      [style.color]="catalogue.style.textColor">
      {{ catalogue.name | uppercase }}
  </h2>
  <p class="catalogue-preview-description" [style.fontFamily]="catalogue.style.bodyFont"
      [style.color]="catalogue.style.textColor">
      {{ catalogue.description | titlecase }}
  </p>
</div>


  <!-- <h2 class="catalogue-preview-name" [style.fontFamily]="catalogue.style.headingFont"
      [style.color]="catalogue.style.textColor">
      {{ catalogue.name | uppercase }}
  </h2>
  <p class="catalogue-preview-description" [style.fontFamily]="catalogue.style.bodyFont"
      [style.color]="catalogue.style.textColor">
      {{ catalogue.description | titlecase }}
  </p> -->
</div>
        </div>
        <div *ngIf="!loading">
          <div *ngFor="let category of groupedProducts | keyvalue" class="category-section"
            [style.border-color]="catalogue?.style?.textColor">

            <!-- Category Title -->
            <h2 class="category-title" [style.fontFamily]="catalogue?.style?.headingFont"
              [style.color]="catalogue?.style?.primaryColor">
              {{ category.key | uppercase }}
            </h2>

            <!-- Products under this category -->
            <div [ngClass]="[
            'product-display-area',
            catalogue?.displayProperties?.layoutStyle,
            'grid-cols-' + catalogue?.displayProperties?.gridColumns
          ]" [style.fontFamily]="catalogue?.style?.bodyFont"
              [style.backgroundColor]="catalogue?.style?.backgroundColor"
              [style.gap.px]="catalogue?.displayProperties?.cardSpacing">

              <!-- Empty case -->
              <div *ngIf="category.value.length === 0" class="no-products-preview-message">
                No products to display in this category.
              </div>

              <!-- Loop through products -->
              <div *ngFor="let product of category.value" class="preview-product" [style.boxShadow]="catalogue?.displayProperties?.cardShadow === 'None' 
       ? 'none' 
       : 'var(--card-shadow-' + catalogue?.displayProperties?.cardShadow?.toLowerCase() + ')'"
                [style.borderRadius.px]="catalogue?.displayProperties?.borderRadius"
                (click)="openProductDetails(product)" style="cursor: pointer;">
                <img [src]="product?.images?.[0]" alt="{{ product?.name }}" class="preview-product-image"
                  [style.aspectRatio]="getAspectRatioValue(catalogue?.displayProperties?.imageAspectRatio)" />

                <div class="preview-product-details">
                  <div class="preview-product-name" [style.fontFamily]="catalogue?.style?.headingFont"
                    [style.color]="catalogue?.style?.textColor">
                    {{ product?.name | titlecase }}
                  </div>

                  <div class="preview-product-price"
                    *ngIf="catalogue?.includePricing && (product?.sellingPrice || product?.price)"
                    [style.color]="catalogue?.style?.textColor">
                    ₹{{ product?.sellingPrice || product?.price?.value || product?.price }}
                  </div>

                  <div class="preview-product-desc" *ngIf="catalogue?.includeDescription && product?.description"
                    [style.color]="catalogue?.style?.textColor">
                    {{ product?.description }}
                  </div>

                  <div class="preview-product-specs" *ngIf="catalogue?.includeSpecifications && product?.specifications"
                    [style.color]="catalogue?.style?.textColor">
                    <p>Specifications: {{ product?.specifications }}</p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>


        <div *ngIf="!loading" class="catalogue-footer" [style.backgroundColor]="catalogue?.style?.backgroundColor"
          [style.color]="catalogue?.style?.textColor" [style.fontFamily]="catalogue?.style?.bodyFont">

          <div class="footer-top">
            <div class="footer-logo-address">
              <img *ngIf="catalogue.businessData.businessLogo; else footerFallback"
                [src]="catalogue.businessData.businessLogo" alt="Company Logo" class="footer-logo" />
              <ng-template #footerFallback>
                <div class="footer-logo-avatar" [style.backgroundColor]="catalogue?.style?.secondaryColor">
                  {{ getInitials(catalogue.businessData.businessName) }}
                </div>
                <p class="footer-business-name" [style.color]="catalogue?.style?.secondaryColor">{{
                  catalogue.businessData.businessName }}</p>
              </ng-template>


              <p class="footer-address">{{ catalogue.businessData.businessAddress }}</p>
            </div>
          </div>

          <div class="footer-contact-grid">
            <div class="footer-contact-item">
              <strong>Email:</strong> {{catalogue.businessData.email || 'N/A' }}
            </div>
            <div class="footer-contact-item">
              <strong>Phone:</strong>{{ catalogue.businessData.contactNumber ||
              'N/A' }}
            </div>
            <div class="footer-contact-item">
              <strong>WhatsApp:</strong> {{ catalogue.businessData.contactNumber ||
              'N/A' }}
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
<div *ngIf="loading" class="loading-section">
  <mat-spinner diameter="40"></mat-spinner>
</div>